// extracted by mini-css-extract-plugin
export default {"bord":"index_bord_StY86","tit":"index_tit_Vx7KG","p10":"index_p10_YxRED","listItem":"index_listItem_gymw6","cRed3":"index_cRed3_0XwK6","cBlue":"index_cBlue_ASSn3"};